var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("Page not found")]),_vm._v(" "),_c('h1',[_vm._v("An error occurred")]),_vm._v(" "),_c('nuxt-link',{attrs:{"to":"/"}},[_vm._v("Home page")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }